module.exports = __webpack_public_path__ + "img/bg-3.56e5e08c.jpg";